import React from "react";
import "./TeaserGrid.css";

export default ({ children }) =>
  <div className="TeaserGrid">
    {children}
  </div>;



// WEBPACK FOOTER //
// ./src/components/TeaserGrid.js